import { createStore } from 'vuex';

// modules안에 있는 .js 파일만 가져옴
const requireModules = require.context('@/store/modules', false, /.*\.js$/);
const modules = {};
requireModules.keys().forEach(key => {
  const regex = /.\/(.*?).js$/;
  const moduleName = regex.test(key) && key.match(regex)[1];
  modules[moduleName] = requireModules(key).default;
});

const store = createStore({
  // strict : false,
  // devtools: true,
  modules: {
    ...modules
  }
});

export default store;